import { render, staticRenderFns } from "./stayWarehousing.vue?vue&type=template&id=368313ce&scoped=true&"
import script from "./stayWarehousing.vue?vue&type=script&lang=js&"
export * from "./stayWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./stayWarehousing.vue?vue&type=style&index=0&id=368313ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368313ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368313ce')) {
      api.createRecord('368313ce', component.options)
    } else {
      api.reload('368313ce', component.options)
    }
    module.hot.accept("./stayWarehousing.vue?vue&type=template&id=368313ce&scoped=true&", function () {
      api.rerender('368313ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/stayWarehousing.vue"
export default component.exports